import type { RouteRecordRaw } from "vue-router"
const Base = () => import("./components/Base.vue")
const Home = () => import("./views/Home.vue")
const Days = () => import("./views/Days.vue")

const routes: RouteRecordRaw[] = [
  {
    path: "/overtime",
    component: Base,
    children: [
      { path: "", component: Home, name: "overtime:home" },
      { path: "days/", component: Days, name: "overtime:days" },
    ],
  },
]

export default routes
